import { useState } from 'react';
import LoadingButton from '../LoadingButton';

export default function RemittanceForm({
  paymentMethods = [],
  isLoading,
  onSubmit,
  onCancel
}) {
  const [formData, setFormData] = useState({
    payment_method: '',
    other_payment_method: '',
    sender_name: '',
    phone_number: '',
    amount: '',
    date: new Date().toISOString().split('T')[0],
    note: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const submitData = {
      ...formData,
      payment_method: formData.payment_method === 'Other' 
        ? formData.other_payment_method 
        : formData.payment_method,
      amount: parseFloat(formData.amount)
    };

    delete submitData.other_payment_method;
    onSubmit(submitData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label htmlFor="amount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Amount
        </label>
        <div className="relative mt-1 rounded-md shadow-sm">
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <span className="text-gray-500 sm:text-sm">$</span>
          </div>
          <input
            type="number"
            name="amount"
            id="amount"
            step="0.01"
            min="0"
            required
            value={formData.amount}
            onChange={handleChange}
            className="block w-full rounded-md border border-gray-300 dark:border-gray-600 pl-7 shadow-sm focus:border-primary focus:ring-primary dark:bg-gray-700 dark:text-white sm:text-sm"
            placeholder="0.00"
          />
        </div>
      </div>

      <div>
        <label htmlFor="payment_method" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Payment Method
        </label>
        <select
          id="payment_method"
          name="payment_method"
          value={formData.payment_method}
          onChange={handleChange}
          className="block w-full rounded-md border border-gray-300 dark:border-gray-600 shadow-sm focus:border-primary focus:ring-primary dark:bg-gray-700 dark:text-white sm:text-sm"
          required
        >
          <option value="">Select payment method</option>
          {paymentMethods.map((method) => (
            <option key={method} value={method}>
              {method}
            </option>
          ))}
          <option value="Other">Other</option>
        </select>
      </div>

      {formData.payment_method === 'Other' && (
        <div>
          <label htmlFor="other_payment_method" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Specify Payment Method
          </label>
          <input
            type="text"
            id="other_payment_method"
            name="other_payment_method"
            value={formData.other_payment_method}
            onChange={handleChange}
            className="block w-full rounded-md border border-gray-300 dark:border-gray-600 shadow-sm focus:border-primary focus:ring-primary dark:bg-gray-700 dark:text-white sm:text-sm"
            required
          />
        </div>
      )}

      <div>
        <label htmlFor="sender_name" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Sender Name
        </label>
        <input
          type="text"
          id="sender_name"
          name="sender_name"
          value={formData.sender_name}
          onChange={handleChange}
          className="block w-full rounded-md border border-gray-300 dark:border-gray-600 shadow-sm focus:border-primary focus:ring-primary dark:bg-gray-700 dark:text-white sm:text-sm"
          required
        />
      </div>

      <div>
        <label htmlFor="phone_number" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Phone Number
        </label>
        <input
          type="tel"
          id="phone_number"
          name="phone_number"
          value={formData.phone_number}
          onChange={handleChange}
          className="block w-full rounded-md border border-gray-300 dark:border-gray-600 shadow-sm focus:border-primary focus:ring-primary dark:bg-gray-700 dark:text-white sm:text-sm"
          required
        />
      </div>

      <div>
        <label htmlFor="date" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Payment Date
        </label>
        <input
          type="date"
          id="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          className="block w-full rounded-md border border-gray-300 dark:border-gray-600 shadow-sm focus:border-primary focus:ring-primary dark:bg-gray-700 dark:text-white sm:text-sm"
          required
        />
      </div>

      <div>
        <label htmlFor="note" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Note (Optional)
        </label>
        <textarea
          id="note"
          name="note"
          value={formData.note}
          onChange={handleChange}
          rows={3}
          className="block w-full rounded-md border border-gray-300 dark:border-gray-600 shadow-sm focus:border-primary focus:ring-primary dark:bg-gray-700 dark:text-white sm:text-sm"
        />
      </div>

      <div className="flex justify-end gap-3 mt-6">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600"
          disabled={isLoading}
        >
          Cancel
        </button>
        <LoadingButton
          type="submit"
          isProcessing={isLoading}
          loadingText="Submitting..."
        >
          Submit Payment
        </LoadingButton>
      </div>
    </form>
  );
}